import React, { useEffect, useState } from "react";
import CookieConsent from "react-cookie-consent";
import { useTranslation } from "react-i18next";

const CookieConsentBanner = () => {
    const { t } = useTranslation();
    const [mounted, setMounted] = useState(false); // contrôle du DOM
    const [animate, setAnimate] = useState(false); // contrôle de la classe d'animation

    useEffect(() => {
        // Montre le DOM immédiatement, mais garde l'opacité à 0
        setMounted(true);
        // Déclenche l'animation juste après
        const timer = setTimeout(() => {
            setAnimate(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const handleAccept = () => {
        if (window.gtag) {
            window.gtag("consent", "update", {
                ad_storage: "granted",
                analytics_storage: "granted",
                ad_user_data: "granted",
                ad_personalization: "granted",
            });
        }
    };

    const handleDecline = () => {
        if (window.gtag) {
            window.gtag("consent", "update", {
                ad_storage: "denied",
                analytics_storage: "denied",
                ad_user_data: "denied",
                ad_personalization: "denied",
            });
        }
    };

    if (!mounted) return null; // Ne rien afficher tant qu'on n'a pas lancé l'animation

    return (
        <div
            className={`fixed bottom-0 left-0 w-full z-[9999] transition-all duration-700 ease-out transform ${animate ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
                }`}
        >            <CookieConsent
            location="bottom"
            containerClasses="fixed bottom-0 left-0 w-full z-[9999]"
            contentClasses="text-justify md:text-left text-sm"
            buttonWrapperClasses="flex items-center justify-center w-full md:contents"
            buttonText={t("global.cookie.accept")}
            declineButtonText={t("global.cookie.decline")}
            enableDeclineButton
            onAccept={handleAccept}
            onDecline={handleDecline}
            style={{
                background: "#04200F",
                color: "#ffffff",
                textAlign: "left",
                fontSize: "14px",
                padding: "16px",
            }}
            buttonStyle={{
                background: "#CEA95A",
                color: "#fff",
                fontSize: "14px",
                padding: "8px 16px",
            }}
            declineButtonStyle={{
                background: "#aaa",
                color: "#fff",
                fontSize: "14px",
                padding: "8px 16px",
            }}
            cookieName="userConsentCookie"
            expires={7}
        >
                {t("global.cookie.text")}
            </CookieConsent>
        </div>
    );
};

export default CookieConsentBanner;